/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const GlassesIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <circle cx="6.5" cy="16.501" r="4" />
      <circle cx="17.5" cy="16.501" r="4" />
      <path d="M10.5,16.501 C10.5,15.673 11.171,15.001 12,15.001 C12.827,15.001 13.5,15.673 13.5,16.501" />
      <path d="M2.5,16.501 L2.5,4.001 C2.5,3.173 3.171,2.501 4,2.501" />
      <path d="M21.5,16.501 L21.5,4.001 C21.5,3.173 20.827,2.501 20,2.501" />
    </g>
  </svg>
);

export default GlassesIcon;
